import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useTheme } from "../../context/ThemeContext";

import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Layout = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { theme } = useTheme();

  // Handle screen resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Set initial state
    checkMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkMobile);

    // Clean up event listener
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Toggle sidebar on mobile
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Close sidebar when clicking outside or on a menu item
  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div
      className={`min-h-screen flex flex-col ${theme === "dark" ? "dark" : ""}`}
    >
      <Navbar onMenuClick={toggleSidebar} />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          isMobile={isMobile}
          isOpen={isMobile ? sidebarOpen : true}
          onClose={closeSidebar}
        />

        {/* Main content area with spacing for fixed navbar and sidebar */}
        <main
          className={`
            flex-1 
            overflow-auto 
            bg-gray-50 
            dark:bg-gray-950 
            min-h-screen
            pt-16 
            transition-all 
            duration-300
            ${!isMobile ? "ml-64" : "ml-0"}
          `}
        >
          <div className="container mx-auto max-w-7xl p-4">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
